import { useLocation, Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
//
import { SellerPublicPageHeader } from './EndUserHeader';
import SellerPageFooter from './SellerPageFooter';
import ThemeUpdater from '../../components/minimal/ThemeUpdater';
import { useSellerPageContext } from '../../context-state/SellerPageContext';
import { IFrameView } from '../../pages/common/event/IFrameView';
import { isInIframe } from '../../utils/iframe';
// ----------------------------------------------------------------------

export default function MainLayout() {
    const { pathname } = useLocation();
    const { accountContext } = useSellerPageContext();
    const { account } = accountContext;

    const isHome = pathname === '/';
    const hideHeader = isInIframe();
    const hideFooter = isInIframe();

    return (
        <IFrameView>
            <ThemeUpdater
                primaryColor={account?.design?.sellerPagePrimaryColor}
                fontFamily={account?.design?.sellerPageFont}
                fontUrl={account?.design?.sellerPageFontUrl}
                titleFontFamily={account?.design?.sellerPageTitleFont}
                titleFontUrl={account?.design?.sellerPageTitleFontUrl}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            ...(!isHome && {
                                pt: { xs: 8, md: 11 },
                            }),
                        }}
                    >
                        {!hideHeader && <SellerPublicPageHeader />}
                        <Box minHeight="50vh">
                            <Outlet />
                        </Box>
                        {!hideFooter && <SellerPageFooter />}
                    </Box>
                </Box>
            </ThemeUpdater>
        </IFrameView>
    );
}
